import getLogger from '@nuuly-ui/core-lib/modules/core/js/logger.js';

import config from '../../../../config/config.js';

const logger = getLogger(config);

export default logger;
